<template>
  <div class="wrap">
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
    <foot-bar ref="foot"></foot-bar>
  </div>
</template>

<script>
// import home from './home'
// import secondHome from '../secondHome'
export default {
  // name: 'index',
  components: {
    // home,
    // secondHome
  },
  data () {
    return {
      // coms: ['home', 'secondHome'],
      active: 'home',
      navIndex: 0
    }
  },
  watch: {
    '$route' (val) {
      // console.log(1)
      // 底部导航foot加菜单，在foot.vue和index这里watch和mounted这两个函数要同步修改
      switch (val.path) {
        case '/': this.$refs.foot.set(0)
          break
        case '/benefit': this.$refs.foot.set(1)
          break
        // case '/college': this.$refs.foot.set(2)
        //   break
        case 'https://appfktptv3l5652.h5.xiaoeknow.com/homepage?entry=2&entry_type=2001': this.$refs.foot.set(2)
          break
        case '/huipinSearch': this.$refs.foot.set(3)
          break
        case '/my': this.$refs.foot.set(4)
      }
    }
  },
  mounted () {
    switch (this.$route.path) {
      case '/': this.$refs.foot.set(0)
        break
      case '/benefit': this.$refs.foot.set(1)
        break
      // case '/college': this.$refs.foot.set(2)
      //   break
      case 'https://appfktptv3l5652.h5.xiaoeknow.com/homepage?entry=2&entry_type=2001': this.$refs.foot.set(2)
        break
      case '/huipinSearch': this.$refs.foot.set(3)
        break
      case '/my': this.$refs.foot.set(4)
    }
  }
}
</script>

<style scoped>
.wrap{
  height: 100%;
  overflow: auto;
  padding-bottom: 60px;
}
</style>



// WEBPACK FOOTER //
// src/view/home/index.vue